import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTypedTheme } from '@monorepo-web/styles';
import { Container, Header } from './style';
import { Calendario } from '../../../';
export default function ModalPersonalizado({ openModal, setOpenModal, containerHeight, obj_datas, dataInicialCarteira, dataFinalCarteira, onSelectAplicar, }) {
    const theme = useTypedTheme();
    return (_jsx(Modal, Object.assign({ open: openModal, onClose: () => setOpenModal(false) }, { children: _jsxs(Container, Object.assign({ containerHeight: containerHeight }, { children: [_jsxs(Header, { children: ["Per\u00EDodo personalizado", _jsx(Close, { onClick: () => setOpenModal(false), sx: {
                                cursor: 'pointer',
                                width: 20,
                                [`@media ${theme.device.mobileXL}`]: {
                                    width: 15,
                                },
                                [`@media ${theme.device.mobileM}`]: {
                                    width: 10,
                                },
                            } })] }), _jsx(Calendario, { setOpenModal: setOpenModal, obj_datas: obj_datas, dataInicialCarteira: dataInicialCarteira, dataFinalCarteira: dataFinalCarteira, onSelectAplicar: onSelectAplicar })] })) })));
}
